var map = {
	"./icon-module-1-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-1-i.svg",
	"./icon-module-2-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-2-i.svg",
	"./icon-module-3-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-3-i.svg",
	"./icon-module-4-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-4-i.svg",
	"./icon-module-5-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-5-i.svg",
	"./icon-module-6-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-6-i.svg",
	"./icon-module-7-i.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/icon-module-7-i.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/svg sync recursive !!./node_modules/html-loader/dist/cjs.js! ^\\.\\/icon\\-module\\-.*\\-i\\.svg$";